<template>
  <div id="app">
    <router-view v-if="showWiew" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import util from '@/libs/util.js'
import { checkCertCenterLogin } from '@/api/sys.login'
export default {
    name: 'app',
    data() {
        return {
            showWiew: false
        }
    },
    mounted() {
        // this.updateColor('#165dff', 'light')
        this.updateColor('#1D6EFA', 'light')
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                this.queryCenter()
            }
        })
        this.queryCenter()
    },
    methods: {
        ...mapActions({
            userSet: 'd2admin/user/set'
        }),
        ...mapActions('d2admin/auth', ['searchMyAuth']),
        ...mapActions('d2admin/page', ['closeAll']),
        ...mapActions('d2admin/account', ['logout']),
        updateColor(primaryColor, themeMode) {
            if (!primaryColor) return
            const style = document.getElementById('admin-style-root-color')
            const mixColor = themeMode === 'dark' ? '#141414' : '#ffffff'
            let innerHTML = `html${
                themeMode === 'dark' ? '.dark' : ''
            }:root{ --el-color-primary: ${primaryColor};\n`
            for (let i = 1; i <= 9; i++) {
                innerHTML += `--el-color-primary-light-${i}: ${this.colorPalette(
                    primaryColor,
                    mixColor,
                    i * 0.1
                )};\n`
            }
            if (style) style.innerHTML = innerHTML + '}'
        },
        colorPalette(color1, neutralColor, weight) {
            weight = Math.max(Math.min(Number(weight), 1), 0)
            const mainColor = this.hexToRgb(color1)
            const mixColor = this.hexToRgb(neutralColor)
            const hex = []
            for (const key in mainColor) {
                const idx = key
                hex.push(
                    Math.round(
                        mainColor[idx] * (1 - weight) + mixColor[idx] * weight
                    )
                )
            }
            return this.rgbToHex({ r: hex[0], g: hex[1], b: hex[2] })
        },
        rgbToHex(rgb) {
            let hex = '#'
            for (const key in rgb) {
                const idx = Math.round(rgb[key])
                hex += idx.toString(16).padStart(2, '0')
            }
            return hex
        },
        hexToRgb(hex) {
            const hxs = hex.replace('#', '').match(/../g) || []
            const newHxs = {}
            for (let i = 0; i < 3; i++) {
                newHxs[['r', 'g', 'b'][i]] = parseInt(hxs[i], 16)
            }
            return newHxs
        },
        getChildAuth(data, auData) {
            if (data.child && data.child.length > 0) {
                for (var i = 0; i < data.child.length; i++) {
                    data.child[i].can_add = false
                    data.child[i].can_del = false
                    data.child[i].can_modify = false
                    auData.push(data.child[i])
                    this.getChildAuth(data.child[i], auData)
                }
            }
        },
        queryCenter() {
            checkCertCenterLogin()
                .then(async res => {
                    if (res.data.status_code == '422') {
                        this.$message.error(res.data.message)
                        !this.showWiew && (this.showWiew = true)
                        return
                    }
                    util.cookies.set('token', 'Bearer ' + res.data.data.token)
                    if (res.data.data.state == '2') {
                        this.loading.close()
                        this.$message({
                            message: '该账户已冻结，不能登录',
                            type: 'error',
                            duration: 5 * 1000
                        })
                        return
                    }
                    if (
                        res.data.data.zi_org_id &&
                        res.data.data.zi_org_state == '2'
                    ) {
                        this.$message({
                            message: '子机构已冻结，不能登录',
                            type: 'error',
                            duration: 5 * 1000
                        })
                        return
                    }
                    if (
                        res.data.data.fu_org_id &&
                        res.data.data.fu_org_state == '2'
                    ) {
                        this.loading.close()
                        this.$message({
                            message: '机构已冻结，不能登录',
                            type: 'error',
                            duration: 5 * 1000
                        })
                        return
                    }
                    const cacheUser = localStorage.getItem('userInfo')
                    if (cacheUser) {
                        const tokenFrom = JSON.parse(cacheUser).tokenFrom
                        if (
                            tokenFrom &&
                            tokenFrom !== res.data.data.tokenFrom
                        ) {
                            !this.showWiew && (this.showWiew = true)
                            this.logout({
                                vm: this
                            })
                            return
                        }
                    }
                    localStorage.setItem(
                        'userInfo',
                        JSON.stringify(res.data.data)
                    )
                    await this.userSet({
                        name: res.data.data.nick_name
                    })
                    !this.showWiew && (this.showWiew = true)
                    this.$nextTick(() => {
                        this.$router.push('/index')
                    })
                })
                .catch(e => {
                    !this.showWiew && (this.showWiew = true)
                })
        }
    }
}
</script>

<style lang="scss">
@import '~@/assets/style/public-class.scss';

.el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
}
.el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}
.el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #ccc;
}
</style>
